import { Component, Input } from '@angular/core';
import { Award } from '@df/interfaces';

@Component({
    selector: 'app-certificate-award',
    templateUrl: './certificate_award.component.html',
    styleUrls: ['./certificate_award.component.scss']
})
export class CertificateAwardComponent {
    @Input() award: Award;
}
